import localStorageService from '@core/persistence/localStorage/localStorageService'
import { AUTH_STORAGE_KEYS } from '@core/persistence/storageKeys'

// "Logged in" is the presence of an access token — the same signal authStore
// derives `isAuthenticated` from and the axios interceptors read on every
// request. The router guard and the `/` hand-off both call this so there is
// exactly one definition of a live session in the app.
//
// Deliberately synchronous and Pinia-free: it runs during route resolution,
// before any component (and therefore any store) is mounted.
export function hasActiveSession(): boolean {
  return Boolean(localStorageService.getItem(AUTH_STORAGE_KEYS.TOKEN))
}
